import { css } from '@/styled-system/css';

export const cardBg = css({
  background: 'bg.softest',
});

export const cardHeader = css({
  display: 'flex',
  alignItems: 'center',
  gap: 'tighter',
  fontSize: 'heading-xs',
  fontWeight: 'regular',
  color: 'text.neutral',
});

export const pageTitle = css({
  display: 'flex',
  alignItems: 'center',
  gap: 'default',
  fontSize: 'heading-sm',
  fontWeight: 'bold',
  color: 'text.neutral',
  marginTop: '0',
  marginBottom: 'default',
});

export const description = css({
  fontSize: 'body',
  color: 'blue.500',
  marginTop: '0',
  marginBottom: 'loose',
  // eslint-disable-next-line hotpads/no-magic-numbers -- unitless numeric; follow-up tokenization
  lineHeight: 1.5,
});

export const infoBanner = css({
  display: 'flex',
  flexDirection: 'column',
  gap: 'tightest',
  background: 'teal.100',
  borderLeftWidth: 'thicker',
  borderLeftStyle: 'solid',
  borderLeftColor: 'border.accent.brand.hero-fixed',
  borderRadius: 'sm',
  paddingTop: 'default',
  paddingBottom: 'default',
  paddingLeft: 'default',
  paddingRight: 'default',
  marginBottom: 'loose',
});

export const infoBannerTitle = css({
  display: 'flex',
  alignItems: 'center',
  gap: 'tighter',
  fontSize: 'body-sm',
  fontWeight: 'regular',
  color: 'teal.600',
});

export const infoBannerText = css({
  fontSize: 'body-sm',
  color: 'blue.500',
  // eslint-disable-next-line hotpads/no-magic-numbers -- unitless numeric; follow-up tokenization
  lineHeight: 1.5,
  marginTop: '0',
  marginBottom: '0',
});

export const form = css({
  display: 'flex',
  flexDirection: 'column',
  gap: 'loose',
});

export const cardBody = css({
  display: 'flex',
  flexDirection: 'column',
  gap: 'loose',
});

export const embeddedSection = css({
  display: 'flex',
  flexDirection: 'column',
  gap: 'default',

  '& + &': {
    borderTopWidth: 'default',
    borderTopStyle: 'solid',
    borderTopColor: 'border.neutral',
    paddingTop: 'loose',
  },
});

export const embeddedSectionHeader = css({
  fontSize: 'body',
  fontWeight: 'bold',
  color: 'text.neutral',
  marginTop: '0',
  marginBottom: '0',
});

export const section = css({
  display: 'flex',
  flexDirection: 'column',
  gap: 'tighter',
});

export const sectionLabel = css({
  fontSize: 'body',
  fontWeight: 'regular',
  color: 'text.neutral',
  marginTop: '0',
  marginBottom: 'tighter',
});

export const radioGroup = css({
  display: 'flex',
  flexDirection: 'column',
  gap: 'tighter',
});

export const helperText = css({
  fontSize: 'body-sm',
  color: 'teal.600',
  marginTop: 'tightest',
});

export const saveRow = css({
  display: 'flex',
  flexDirection: 'column',
  gap: 'default',
  lg: {
    flexDirection: 'row',
    justifyContent: 'flex-end',
  },
  paddingTop: 'default',
});
